// This is a hack to work around the fact that UJS disables the submit button when
// clicked, and the "Export" submit button returns a CSV file, so the page isn't
// refreshed and the button stays disabled. This re-enables the button after 100ms
$(document).on("submit", "#alerts-table", function () {
  const form = $(this);

  setTimeout(function () {
    form.find('[type="submit"]').prop("disabled", false);
  }, 100);
});
